var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */

import { css, keyframes } from '@emotion/react';
import { logicalCSS, euiCantAnimate } from '../../global_styling';
var tableLoadingLine = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  from {\n    ", "\n    ", "\n  }\n\n  20% {\n    ", "\n    ", "\n  }\n\n  80% {\n    ", "\n    ", "\n  }\n\n  100% {\n    ", "\n    ", "\n  }\n"])), logicalCSS('left', 0), logicalCSS('width', 0), logicalCSS('left', 0), logicalCSS('width', '40%'), logicalCSS('left', '60%'), logicalCSS('width', '40%'), logicalCSS('left', '100%'), logicalCSS('width', 0));
export var euiBasicTableBodyLoading = function euiBasicTableBodyLoading(_ref2) {
  var euiTheme = _ref2.euiTheme;
  return /*#__PURE__*/css("position:relative;overflow:hidden;&::before{position:absolute;content:'';", logicalCSS('width', '100%'), " ", logicalCSS('height', euiTheme.border.width.thick), " background-color:", euiTheme.colors.primary, ";animation:", tableLoadingLine, " 1s linear infinite;", euiCantAnimate, "{animation-duration:2s;}};label:euiBasicTableBodyLoading;");
};

// Fix to make the loading indicator position correctly in Safari
// For whatever annoying reason, Safari doesn't respect `position: relative;`
// on `tbody` without `position: relative` on the parent `table`
var _ref = process.env.NODE_ENV === "production" ? {
  name: "6xbnw4-safariLoadingWorkaround",
  styles: "position:relative;label:safariLoadingWorkaround;"
} : {
  name: "6xbnw4-safariLoadingWorkaround",
  styles: "position:relative;label:safariLoadingWorkaround;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export var safariLoadingWorkaround = function safariLoadingWorkaround() {
  return _ref;
};

// Unsets the extra height caused by tooltip/popover wrappers around table action buttons
// Without this, the row height jumps whenever actions are disabled
export var euiBasicTableActionsWrapper = process.env.NODE_ENV === "production" ? {
  name: "1mshepa-euiBasicTableActionsWrapper",
  styles: "line-height:1;label:euiBasicTableActionsWrapper;"
} : {
  name: "1mshepa-euiBasicTableActionsWrapper",
  styles: "line-height:1;label:euiBasicTableActionsWrapper;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};